// theme.js
import {createTheme} from "@material-ui/core/styles";
import colors from "./colors"; // your custom file

const theme = createTheme({
	palette: {
		primary: {
			main: colors.primary,
		},
	},
	overrides: {
		MuiInputLabel: {
			root: {
				"&$focused": {
					color: colors.primary,
				},
			},
		},
		MuiOutlinedInput: {
			root: {
				"&$focused $notchedOutline": {
					borderColor: colors.primary,
				},
			},
		},
		MuiButton: {
			containedPrimary: {
				backgroundColor: colors.primary,
				"&:hover": {
					backgroundColor: colors.primary, // darker shade if you want
					opacity: 0.9,
				},
				color: colors.white,
			},
			outlinedPrimary: {
				borderColor: colors.primary,
				color: colors.primary,
				"&:hover": {
					borderColor: colors.primary,
					backgroundColor: "rgba(0,0,0,0.04)",
				},
			},
			textPrimary: {
				color: colors.primary,
			},
		},
	},
});

export default theme;
